import isEmpty from 'lodash/isEmpty';
import Config from 'react-native-config';
import { Thunk } from 'store/types';
import { MhpDetails } from './types';

export const DELETE_DOCUMENT = `MESSAGE.DELETE_DOCUMENT`;
export const DELETE_DOCUMENT_SUCCESS = `MESSAGE.DELETE_DOCUMENT_SUCCESS`;
export const DELETE_DOCUMENT_FAIL = `MESSAGE.DELETE_DOCUMENT_FAIL`;

export const deleteDocument = (
  messageUUID: string,
  attachmentUUID: string
): Thunk => async dispatch => {
  let formBody = [];
  let url = '/attachment';
  const headers: {
    'Content-Type': string;
    'mhp-message-uuid'?: string;
    'mhp-filter-resource-id'?: string;
  } = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  };

  formBody.push(`${encodeURIComponent('messageUUID')}=${encodeURIComponent(messageUUID)}`);
  formBody.push(`${encodeURIComponent('attachmentUUID')}=${encodeURIComponent(attachmentUUID)}`);
  if (Config.MESSAGING_EXPANSION_BASE_URL) {
    url = '/adapters/utah/attachments/id';
    formBody = [];
    headers['mhp-message-uuid'] = messageUUID;
    headers['mhp-filter-resource-id'] = attachmentUUID;
  }

  const formBodyString = formBody.join('&');
  const result = await dispatch({
    type: DELETE_DOCUMENT,
    payload: {
      client: 'messaging',
      request: {
        method: 'delete',
        headers,
        url,
        data: formBodyString
      }
    }
  });

  return result;
};

interface GetMessageByIdPayload {
  method: string;
  url: string;
  params?: {
    messageFolder: 'inbox' | 'outbox';
    messageId: string;
    source: 'cdr' | 'cerner';
  };
  headers?: {};
}

export const GET_MESSAGE_BY_ID = 'MESSAGING.GET_MESSAGE_BY_ID';
export const GET_MESSAGE_BY_ID_SUCCESS = 'MESSAGING.GET_MESSAGE_BY_ID_SUCCESS';
export const GET_MESSAGE_BY_ID_FAIL = 'MESSAGING.GET_MESSAGE_BY_ID_FAIL';
export const getMessageById = (
  messageId: string,
  messageFolder: 'inbox' | 'outbox',
  source: 'cdr' | 'cerner' = 'cerner',
  mhpDetails: MhpDetails | undefined = undefined
) => {
  let payloadReq: GetMessageByIdPayload = {
    method: 'get',
    url: '/messages/details',
    params: {
      messageFolder,
      messageId,
      source
    }
  };

  if (mhpDetails?.url) {
    payloadReq = {
      ...payloadReq,
      url: mhpDetails.url
    };
  }

  if (!isEmpty(mhpDetails?.headers)) {
    payloadReq.headers = mhpDetails?.headers;
    delete payloadReq.params;
  }

  return {
    type: GET_MESSAGE_BY_ID,
    payload: {
      client: 'messaging',
      request: payloadReq
    }
  };
};

export const MESSAGE_COMPOSE_CLEAR_PROVIDER_SELECTED =
  'MESSAGE.MESSAGE_COMPOSE_CLEAR_PROVIDER_SELECTED';
export const messageComposeClearProviderSelected = () => ({
  type: MESSAGE_COMPOSE_CLEAR_PROVIDER_SELECTED
});
